export const HomeIcon = () => (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M4.38483 19.1026L3.72352 10.2606C3.67657 9.63282 3.94778 9.02339 4.44558 8.63805L11.1583 3.44187C11.6539 3.05829 12.3461 3.05829 12.8417 3.44187L19.5544 8.63805C20.0522 9.02338 20.3234 9.63282 20.2765 10.2606L19.6152 19.1026C19.5615 19.8202 18.9636 20.375 18.244 20.375L15.25 20.375C15.0429 20.375 14.875 20.2071 14.875 20L14.875 15.981C14.875 15.3596 14.3713 14.856 13.75 14.856L10.25 14.856C9.62868 14.856 9.125 15.3596 9.125 15.981L9.125 20C9.125 20.2071 8.95711 20.375 8.75 20.375L5.756 20.375C5.03639 20.375 4.4385 19.8202 4.38483 19.1026Z'
      fillOpacity='var(--nav-icon-fill-opacity, 0)'
      fill='currentColor'
      stroke='currentColor'
      strokeWidth='1.25'
    />
  </svg>
);
